<div class="confirm-modal ig-modal edit-event-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">EDIT CITY</div>

    <div class="edit-wrap">
        <div>
            <div class="edit-event-fields">
                <div class="text-left m-b-3">Editing for {{feed.title}}</div>
                <ig-row>
                    <ig-col [xs]="12" [md]="12" class="relative">
                        <p>Block Navigator Background Image:</p>
                        <div style="height:224px">
                            <img #img *ngIf="selectedImageData"
                                 [src]="imageService.safeImage(selectedImageData)"
                                 width="60%" height="200px" alt="">

                            <div #mask *ngIf="selectedImageData" class="img-mask"
                                 (click)="imageSelector.click()">
                                <!-- <span>Change Image (2MB Maximum)</span> -->
                            </div>
                            <input type="file" class="invisible"
                                   accept="image/png,image/gif,image/jpeg"
                                   #imageSelector
                                   (change)="onImageChange($event)">
                        </div>
                    </ig-col>
                </ig-row>

                <ig-mat-field label="Display Title"
                              [(ngModel)]="feed.cityTitle"
                              [formControl]="cityForm.get('title')">
                </ig-mat-field>
            </div>
        </div>


    </div>
    <ig-row [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="btn-primary" [disabled]="!cityForm.valid" #confirmButton color="primary" size="md"
                       [isAsync]="true"
                       (trigger)="confirm($event)">
                Save
            </ig-button>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.city.modal/edit.city.modal.component.html